/**
 * Session types — derived from `window.location.pathname`. Path-suffix
 * detection mirrors the webpack-era `resolveSessionTypeFromPath`.
 */
export enum SessionType {
  PAYMENT = 'PAYMENT',
  TOKENIZATION = 'TOKENIZATION',
}

/**
 * Adyen payment result codes. Subset relevant to the drop-in's flow; full
 * enumeration lives at https://docs.adyen.com/online-payments/payment-result-codes/.
 */
export enum AdyenPaymentResultCode {
  AUTHORISED = 'Authorised',
  REFUSED = 'Refused',
  ERROR = 'Error',
  CANCELLED = 'Cancelled',
  PENDING = 'Pending',
  RECEIVED = 'Received',
}

/**
 * Adyen card-component field types. Ported from the webpack-era
 * `AdyenCardComponentFieldType` (used in onFieldValid to map blob → encrypted
 * card data).
 */
export enum AdyenCardComponentFieldType {
  ENCRYPTED_CARD_NUMBER = 'encryptedCardNumber',
  ENCRYPTED_EXPIRY_DATE = 'encryptedExpiryDate',
  ENCRYPTED_SECURITY_CODE = 'encryptedSecurityCode',
}

/**
 * Lifecycle status shared by the Adyen Card and Apple Pay flows. Lives here
 * (rather than inside `use-adyen-checkout.ts`) so `useAdyenCheckout` and
 * `useApplePay` can both depend on it without importing from one another.
 */
export enum AdyenCheckoutStatus {
  INITIAL = 'INITIAL',
  PREPARING = 'PREPARING',
  READY = 'READY',
  SUBMITTING = 'SUBMITTING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
